<mojo-reports-job-list-common
  [innerTitle]="false"
  [jobTitle]="'Views by jobs'"
  [leftColumnTitle]="'Total'"
  [rightColumnTitle]="'        Shortlist statuses'"
  [allJobs]="pipelineAllActiveJobs"
>
  <mojo-pipeline-job-item
    job-item
    *ngFor="let job of pipelineAllActiveJobs?.content"
    [jobItem]="job"
    [aggregatedJobData]="getAggregatedJobData(job.id) | async"
  >
  </mojo-pipeline-job-item>
  <mojo-pagination
    pagination
    [pagination]="pipelineAllActiveJobs"
    (pageChange)="pageChange($event)"
  >
  </mojo-pagination>
</mojo-reports-job-list-common>
